/**
 * Backoffice `company-credits` 相关路径。
 * 完整 URL = `backofficeUrlBase` + `/backoffice` + path
 */
export const CreditsPaths = {
    /** POST 公司积分充值 */
    companyRecharge: '/company-credits/recharge',
    /** GET 公司积分充值明细（BO 聚合 s-platform-credits） */
    companyRechargeDetail: '/company-credits/:company_id/recharge-detail',
    /** GET 公司积分消耗明细（BO 聚合 s-platform-credits） */
    companyConsumptionDetail: '/company-credits/:company_id/consumption-detail',
    /** GET 公司积分消耗明细导出 */
    companyConsumptionDetailDownload: '/company-credits/:company_id/consumption-detail/download',
    companyCreditGroups: '/company-credits/:company_id/groups',
    companyCreditGroup: '/company-credits/:company_id/groups/:group_id',
    companyCreditGroupAllocations: '/company-credits/:company_id/groups/:group_id/allocations',
    companyCreditGroupAllocationsRelease: '/company-credits/:company_id/groups/:group_id/allocations/release',
    companyCreditGroupUsers: '/company-credits/:company_id/groups/users',
    companyCreditGroupAllocationDetails: '/company-credits/:company_id/groups/:group_id/allocation-details',
    /** GET 租户用户个人积分充值明细 */
    tenantUserRechargeDetail: '/tenant-user-credits/:tenant_user_id/recharge-detail',
    /** GET 租户用户个人积分消耗明细 */
    tenantUserConsumptionDetail: '/tenant-user-credits/:tenant_user_id/consumption-detail',
    /** GET 租户用户个人积分消耗明细导出 */
    tenantUserConsumptionDetailDownload: '/tenant-user-credits/:tenant_user_id/consumption-detail/download',
    /** PUT 租户用户每日积分上限 */
    tenantUserDailyCreditLimit: '/tenant-users/:tenant_user_id/daily-credit-limit',
};
